module.exports = __webpack_public_path__ + "img/VillaLoreto_Room4.24de3d43.jpg";